<template>
    <div>
        <b-tabs lazy card>
            <b-tab title="LIST USERS">
                <ListUsers />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import ListUsers from '@/components/Users/ListUsers'

    export default {
        name: "UsersMain",
        components: {ListUsers},
        data: function(){
            return {}
        },
        methods: {},
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);

            if (this.packet.userDetails.userrole != 'admin'){
                localStorage.clear()
                this.$router.push("/")
            }
        }

    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Users/UsersMain.vue